module.exports = __webpack_public_path__ + "static/media/Staff-Loans-and-Advances-Application-Form-Blank.d4483dc8.docx";